import dayjs from 'dayjs'

/**
 * @param {number} epoch
 * @return {string}
 */
export function formatLastSeenDate(epoch) {
  return epoch > 0 ? dayjs(epoch * 1000).format('D MMM, h:mma') : 'Not seen'
}
